<template>
  <v-dialog v-model="isLoading" hide-overlay persistent width="300">
    <v-card color="primary" dark>
      <div class="d-flex">
        <img class="spin ml-1 align-self-center" src="../../assets/icons/chainring_white.png" height="48px">
        <v-card-text>
          {{ message }} {{ !indeterminate && percentage ? `${percentage}%` : '' }}
          <v-progress-linear
            ref="progressBar"
            color="white"
            class="mb-0"
            v-model="percentage"
            :indeterminate="true"
          />
        </v-card-text>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import logger from '@/domain/ClientLogger';

export default {
  name: 'loading-dialog',
  props: {
    isLoading: {
      type: Boolean,
      required: false,
      default: false,
    },
    indeterminate: {
      type: Boolean,
      required: false,
      default: true,
    },
    message: {
      type: String,
      required: false,
      default: 'Loading, please wait ...',
    },
    percentage: {
      type: [String, Number],
      required: false,
      default: 0,
    },
  },
  methods: {
  },
};
</script>
